import config from "../config/config";
import axios from "axios";
import { getToken } from "../Token";
import * as url from "../helpers/url_helper";
import { getTimezoneInfo } from '../helpers/timezone_helper';

const { timezoneName, formattedOffset } = getTimezoneInfo();
const token = getToken();

const getAxiosConfig = (endpoint, data) => ({
    method: 'post',
    url: `${config.API_URL}${endpoint}`,
    headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        "Timezone-Name": timezoneName,
        "Timezone-Offset": formattedOffset,
    },
    data
});

export const UserApis = {

    // Fetch vendors (salon admins)
    getVendors: async (data) => {
        return await axios(getAxiosConfig(url.GET_USERS_BY_ROLE, {
            ...data,
            role_id: 2 // for vendor (salon Admin)
        }));
    },

    // Fetch users (role_id = 5)
    getUsers: async (data) => {
        return await axios(getAxiosConfig(url.GET_USERS_BY_ROLE, {
            ...data,
            role_id: 5 // for users
        }));
    },

    // ✅ Fetch all users without filtering by role
    getAllUsers: async (data = {}) => {
        return await axios(getAxiosConfig(url.GET_USERS_BY_ROLE, {
            ...data,
        }));
    },
        getAdminUsers: async (data = {}) => {
        return await axios(getAxiosConfig(url.GET_ADMIN_USERS, {
            ...data,
        }));
    },


    // ✅ Fetch a single user by ID
   getUserById: async (id) => {
  if (!id) throw new Error("User ID is required");

  try {
    return await axios({
      method: "get",
      url: `${config.API_URL}${url.GET_USER_BY_ID}/${id}`, // append /{id}
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        "Timezone-Name": timezoneName,
        "Timezone-Offset": formattedOffset,
      },
    });
  } catch (err) {
    console.error("Error in getUserById:", err.response || err);
    throw err; // re-throw so frontend can handle it
  }
    }
};
